import DefaultIcon from '@material-ui/icons/ViewList';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import React from 'react';
import {Admin, Resource, CustomRoutes} from 'react-admin';
import SettingsIcon from '@material-ui/icons/Settings';
import People from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import CategoryIcon from '@material-ui/icons/Category';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import RoomService from '@material-ui/icons/RoomService';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {CategoryCreate} from './components/categories/CategoryCreate';
import {CategoryEdit} from './components/categories/CategoryEdit';
import {CategoryList} from './components/categories/CategoryList';
import {ColumnCreate, ColumnEdit} from './components/columns/ColumnViews';
import {СolumnList} from './components/columns/СolumnList';
import {HashTagCreate} from './components/hashTag/HashTagCreate';
import {HashTagEdit} from './components/hashTag/HashTagEdit';
import {HashTagList} from './components/hashTag/HashTagList';
import {HashTagCategoriesCreate} from './components/hashTagCategories/HashTagCategoriesCreate';
import {HashTagCategoriesEdit} from './components/hashTagCategories/HashTagCategoriesEdit';
import {HashTagCategoriesList} from './components/hashTagCategories/HashTagCategoriesList';
import {HashTagsForCategoryCreate} from './components/hashTagListCategory/HashTagsForCategoryCreate';
import {HashTagsForCategoryEdit} from './components/hashTagListCategory/HashTagsForCategoryEdit';
import {HashTagsForCategoryList} from './components/hashTagListCategory/HashTagsForCategoryList';
import {HashTagsForCategoryShow} from './components/hashTagListCategory/HashTagsForCategoryShow';
import {HashTagRecommendCreate} from './components/hashTagListRecommend/HashTagRecommendCreate';
import {HashTagRecommendEdit} from './components/hashTagListRecommend/HashTagRecommendEdit';
import {HashTagRecommendList} from './components/hashTagListRecommend/HashTagRecommendList';
import {InquiryManagement} from './components/inquiryManagement/InquiryManagement';
import {InquiryShow} from './components/inquiryManagement/InquiryShow';
import Login from './components/Login';
import MyLayout from './components/MyLayout';
import {SalonEdit} from './components/salon/SalonEdit';
import {StylePostEdit} from './components/stylePosts/StylePostEdit';
import {StylePostShow} from './components/stylePosts/StylePostShow';
import {UserList} from './components/users/UserList';
import {UserShow} from './components/users/UserShow';
import {UserCreate, UserEdit} from './components/users/UserViews';
import {CampaignEdit} from './components/Campaign/CampaignEdit'
import {CampaignList} from './components/Campaign/CampaignList';
import post from './components/utils/customReducer/postUserReducer';
import {IMenuGroup} from './consts/interfaces/Interfaces';

import {ServicesCategoriesShow} from './components/services/ServicesCategoriesShow';
import {ServicesCategoriesEdit} from './components/services/ServicesCategoriesEdit';
import {ServicesCategoriesCreate} from './components/services/ServicesCategoriesCreate';

import {ServicesEdit} from './components/services/ServicesEdit';
import {ServicesCreate} from './components/services/ServicesCreate';

import {CountriesShow} from './components/areas/CountriesShow';
import {CountriesEdit} from './components/areas/CountriesEdit';
import {CountriesCreate} from './components/areas/CountriesCreate';

import {CitiesEdit} from './components/areas/CitiesEdit';
import {CitiesCreate} from './components/areas/CitiesCreate';

import {AreasEdit} from './components/areas/AreasEdit';
import {AreasCreate} from './components/areas/AreasCreate';

import {CurrencyShow} from './components/currency/CurrencyShow';
import {CurrencyEdit} from './components/currency/CurrencyEdit';
import {CurrencyCreate} from './components/currency/CurrencyCreate';

import {IpListEdit} from './components/ip_lists/IpListEdit';
import {IpListCreate} from './components/ip_lists/IpListCreate';

import {ReportsList} from './components/reports/ReportsList';

import {StatsEdit} from './components/stats/StatsEdit'
import {StatsList} from './components/stats/StatsList';

import {AdminLogsList} from './components/admin_logs/AdminLogsList';

import {
    COLUMN,
    COLUMN_CATEGORY,
    HAIR_PRODUCT,
    HASHTAGS_LIST_TYPES,
    HASHTAG_CATEGORY,
    HASHTAG_CATEGORY_LIST,
    HASHTAG_MULTIPLE_LIST,
    HASHTAG_RECOMMEND_LIST,
    HASH_TAG,
    INQUIRY,
    KEYWORDS,
    PERMISSIONS,
    REPORT_TYPES,
    SALON,
    STYLE_COMMENT,
    STYLE_POST,
    STYLE_REPORT,
    STYLE_REVIEW,
    STYLIST_INFO,
    USER,
    REPORTS,
    NOTIFICATIONS,
    CAMPAIGN,
    SERVICES,
    SERVICES_CATEGORIES,
    COUNTRIES,
    CITIES,
    AREAS,
    CURRENCIES,
    IP_LISTS,
    COLUMN_HAIR_SERVICE,
    ADMIN_LOGS,
    APP_VERSIONS, SETTINGS, BONUS_TASK, BONUS_COUPON, BONUS_INFO_TAG, ADMIN_USER_CREDENTIALS, SMS_PROVIDERS
} from './consts/Names';
import {authProvider} from './providers/authProvider';
import myProvider from './providers/myProvider';
import {StylePostList} from './components/stylePosts/StylePostList';
import {NotificationsList} from './components/notifications/NotficationsList';
import {NotificationAdd} from './components/notifications/NotficationAdd';
import {Redirect, Route} from "react-router-dom";
import RedirectToBookings from "./components/redirects/RedirectToBookings";
import {BonusTaskList} from "./components/bonusTasks/BonusTaskList";
import {BonusTaskEdit} from "./components/bonusTasks/BonusTaskEdit";
import {BonusCouponList} from "./components/bonusCoupons/BonusCouponList";
import {BonusCouponEdit} from "./components/bonusCoupons/BonusCouponEdit";
import {BonusInfoTagsList} from "./components/BonusInfoTags/BonusInfoTagsList";
import {BonusInfoTagEdit} from "./components/BonusInfoTags/BonusInfoTagEdit";
import {BonusInfoTagCreate} from "./components/BonusInfoTags/BonusInfoTagCreate";
import {AdminUserCredentialsShow} from "./components/AdminUserCredentials/AdminUserCredentialsShow";
import {AdminUserCredentialsEdit} from "./components/AdminUserCredentials/AdminUserCredentialsEdit";
import {AdminUserCredentialsCreate} from "./components/AdminUserCredentials/AdminUserCredentialsCreate";
import {BonusTaskCreate} from "./components/bonusTasks/BonusTaskCreate";
import {SmsProviderList} from "./components/SmsProviders/SmsProviderList";
import {SmsProviderEdit} from "./components/SmsProviders/SmsProviderEdit";

const messages = {
    en: englishMessages
};

const i18nProvider = polyglotI18nProvider((locale) => messages[locale]);

const group_1 = {id: 1, name: 'Posts & Hashtags', icon: <AssignmentIcon />} as IMenuGroup;
const group_2 = {id: 2, name: 'Article Management', icon: <DefaultIcon />} as IMenuGroup;

const App = () => {
    return (
        <Admin locale="en" layout={MyLayout} loginPage={Login} dataProvider={myProvider} authProvider={authProvider} customReducers={{post}} i18nProvider={i18nProvider}
               customRoutes={[
                   <Route exact path="/services/create" ><ServicesCreate basePath={''} resource={SERVICES.SOURCE} /> </Route>,
                   <Route exact path="/iplist/create" ><IpListCreate basePath={''} resource={IP_LISTS.SOURCE} /> </Route>,
                   <Route exact path="/iplists/:id" ><IpListEdit basePath={''} resource={IP_LISTS.SOURCE} /> </Route>,
                   <Route exact path="/currencies/create" ><CurrencyCreate basePath={''} resource={CURRENCIES.SOURCE} /> </Route>,
                   <Route exact path="/currencies/:id" ><CurrencyEdit basePath={''} resource={CURRENCIES.SOURCE} /> </Route>,
                   <Route exact path="/services/:id" > <ServicesEdit basePath={''} resource={SERVICES.SOURCE} ></ServicesEdit> </Route>,
                   <Route exact path="/cities/create"  > <CitiesCreate basePath={''} resource={CITIES.SOURCE} ></CitiesCreate> </Route>,
                   <Route exact path="/cities/:id" > <CitiesEdit basePath={''} resource={CITIES.SOURCE} ></CitiesEdit> </Route>,
                   <Route exact path="/areas/create" > <AreasCreate basePath={''} resource={AREAS.SOURCE} ></AreasCreate> </Route>,
                   <Route exact path="/areas/:id" > <AreasEdit basePath={''} resource={AREAS.SOURCE} ></AreasEdit> </Route>,
               ]}
        >
            {(permissions: string) => {
                const isAdmin = permissions === PERMISSIONS.ADMIN;
                const isContentManager = permissions === PERMISSIONS.CONTENT_MANAGER;
                const isCustomerSupportManager = permissions === PERMISSIONS.CUSTOMER_SUPPORT_MANAGER;
                return [
                    // isAdmin || isCustomerSupportManager ? (
                    //     <Resource name={ADMIN_LOGS.SOURCE}
                    //               options={{label: 'Logs'}}
                    //               list={AdminLogsList}
                    //     />
                    // ) : null,
                    // isAdmin || isContentManager || isCustomerSupportManager ? (
                    //    <Resource name={USER.SOURCE} 
                    //              options={{label: 'User Management'}}
                    //              list={UserList}
                    //              show={UserShow}
                    //              create={isAdmin ? UserCreate : null} 
                    //              edit={UserEdit}
                    //              icon = {People}
                    //    />
                    // ) : null,

                    // isContentManager || isAdmin || isCustomerSupportManager ? (
                    //    <Resource name={STYLE_POST.SOURCE} 
                    //              options={{label: 'Posts', group: group_1}}
                    //              show={StylePostShow} 
                    //              edit={StylePostEdit} 
                    //              list={StylePostList}
                    //              icon={AssignmentIcon}
                    //    />
                    // ) : null,
                    isAdmin ? (
                        <Resource
                            name={HASH_TAG.SOURCE}
                            options={{label: 'Hashtags', group: group_1}}
                            list={isAdmin ? HashTagList : null}
                            create={isAdmin ? HashTagCreate : null}
                            edit={HashTagEdit}
                            icon={LocalOfferIcon}
                        />
                    ) : null,
                    isAdmin ? (
                        <Resource
                            name={HASHTAG_CATEGORY.SOURCE}
                            options={{label: 'Categories', group: group_1}}
                            list={HashTagCategoriesList}
                            create={HashTagCategoriesCreate}
                            edit={HashTagCategoriesEdit}
                        />
                    ) : null,

                    // isCustomerSupportManager || isAdmin ? (
                    //     <Resource
                    //         name={CAMPAIGN.SOURCE}
                    //         options={{label: 'Campaign Management'}}
                    //         list={CampaignList}
                    //         // create={CampaignCreate}
                    //         edit={CampaignEdit}
                    //     />
                    // ) : null,

                    // isAdmin ? (
                    //     <Resource
                    //         name={SETTINGS.SOURCE}
                    //         options={{label: 'Settings'}}
                    //         list={StatsList}
                    //         edit={StatsEdit}
                    //         icon={SettingsIcon}
                    //     />
                    // ) : null,
                    isAdmin ? (
                        <Resource
                            name={HASHTAG_RECOMMEND_LIST.SOURCE}
                            options={{label: 'Suggested Hashtags', group: group_1}}
                            list={HashTagRecommendList}
                            create={HashTagRecommendCreate}
                            edit={HashTagRecommendEdit}
                            icon={LoyaltyIcon}
                        />
                    ) : null,
                    isAdmin ? (
                        <Resource
                            name={HASHTAG_CATEGORY_LIST.SOURCE}
                            options={{label: 'List for categories', group: group_1}}
                            list={HashTagsForCategoryList}
                            create={HashTagsForCategoryCreate}
                            show={HashTagsForCategoryShow}
                            edit={HashTagsForCategoryEdit}
                            icon={CategoryIcon}
                        />
                    ) : null,

                    isContentManager || isAdmin ? (
                        <Resource name={COLUMN.SOURCE} options={{label: 'Articles', group: group_2}} list={СolumnList} create={ColumnCreate} edit={ColumnEdit} />
                    ) : null,

                    // <Resource name={KEYWORDS.SOURCE} options={{label: 'Trending Keywords', group: group_2}} list={KeywordsList} create={KeywordsCreate} edit={KeywordsEdit} />,
                    isAdmin || isCustomerSupportManager ? <Resource name={INQUIRY.SOURCE} options={{label: 'Inquiry Management'}} list={InquiryManagement} show={InquiryShow} /> : null,
                    isAdmin || isCustomerSupportManager ? (
                        <Resource name={REPORTS.SOURCE}
                                  options={{label: 'Reports'}}
                                  list={ReportsList}
                                  icon={EqualizerIcon}
                        />
                    ) : null,
                    isAdmin ? <Resource name={SALON.SOURCE} edit={SalonEdit} /> : null,
                    isAdmin ? <Resource name={STYLIST_INFO.SOURCE} /> : null,
                    <Resource name={COLUMN_HAIR_SERVICE.SOURCE} />,
                    <Resource name={HAIR_PRODUCT.SOURCE} />,
                    <Resource name={STYLE_COMMENT.SOURCE} />,
                    <Resource name={STYLE_REVIEW.SOURCE} />,
                    <Resource name={STYLE_REPORT.SOURCE} />,
                    <Resource name={REPORT_TYPES.SOURCE} />,
                    <Resource name={HASHTAGS_LIST_TYPES.SOURCE} />,
                    // isAdmin || isCustomerSupportManager ? <Resource name={NOTIFICATIONS.SOURCE} options={{label: 'Push Notifications'}} list={NotificationsList} create={NotificationAdd} /> : null,
                    // isAdmin ? <Resource name={SNAPSHOT.SOURCE} options={{label: 'List of snapshots',group:group_4}} list={SnapshotsList} create={SnapshotsCreate} edit ={SnapshotsEdit} /> : null,
                    // isAdmin ? <Resource name={SNAPSHOT_HASHTAGS.SOURCE} options={{label: 'Snapshots hashtags',group:group_4}} list={snapshotHashTagList}    /> : null,
                    // isAdmin  ? <Resource name={CURRENCIES.SOURCE}  /> : null,


                    isAdmin  ? <Resource name={IP_LISTS.SOURCE}
                        // options={{label: 'IP Management'}}
                        // list={IpListShow}
                        // create={IpListCreate}
                        // edit={IpListEdit}
                        //             icon={PermScanWifiIcon}
                    /> : null,



                    // isContentManager || isAdmin ? (
                    //     <Resource
                    //         name={SERVICES_CATEGORIES.SOURCE}
                    //         icon={RoomService}
                    //         options={{label: 'Service Management'}}
                    //         list={ServicesCategoriesShow}
                    //         show={ServicesCategoriesShow}
                    //         edit={ServicesCategoriesEdit}
                    //         create={isAdmin ? ServicesCategoriesCreate : null}
                    //     />
                    // ) : null,
                    // isContentManager || isAdmin ? (
                    //     <Resource
                    //         name={SERVICES.SOURCE}
                    //     />
                    // ) : null,

                    <Resource
                        name={COUNTRIES.SOURCE}
                        icon={LocationOnIcon}
                        options={{label: 'Locations'}}
                        list={isAdmin || isContentManager ? CountriesShow : null}
                        show={isAdmin || isContentManager ? CountriesShow : null}
                        edit={isAdmin || isContentManager ? CountriesEdit : null}
                        create={isAdmin ? CountriesCreate : null}
                    />,
                    // isAdmin ? (
                    //     <Resource
                    //         name={BONUS_TASK.SOURCE}
                    //         options={{label: 'Bonus Tasks'}}
                    //         list={BonusTaskList}
                    //         edit={BonusTaskEdit}
                    //         create={isAdmin ? BonusTaskCreate : null}
                    //     />
                    // ) : null,,
                    // isAdmin ? (
                    //     <Resource
                    //         name={SMS_PROVIDERS.SOURCE}
                    //         options={{label: 'SMS PROVIDERS'}}
                    //         list={SmsProviderList}
                    //         edit={SmsProviderEdit}
                    //         create={null}
                    //     />
                    // ) : null,
                    // isAdmin ? (
                    //     <Resource
                    //         name={ADMIN_USER_CREDENTIALS.SOURCE}
                    //         options={{label: 'Admin User Credentials'}}
                    //         list={AdminUserCredentialsShow}
                    //         edit={AdminUserCredentialsEdit}
                    //         create={AdminUserCredentialsCreate}
                    //     />
                    // ) : null,
                    // isAdmin ? (
                    //     <Resource
                    //         name={BONUS_INFO_TAG.SOURCE}
                    //         options={{label: 'Bonus Info tags'}}
                    //         list={BonusInfoTagsList}
                    //         edit={BonusInfoTagEdit}
                    //         create={BonusInfoTagCreate}
                    //     />
                    // ) : null,
                    // isAdmin ? (
                    //     <Resource
                    //         name={BONUS_COUPON.SOURCE}
                    //         options={{label: 'Bonus Coupons'}}
                    //         list={BonusCouponList}
                    //         edit={BonusCouponEdit}
                    //     />
                    // ) : null,

                    isContentManager || isAdmin || isCustomerSupportManager ? (
                        <Resource name={'bookings'} options={{label: 'New Admin Panel'}} list={RedirectToBookings}/>
                    ) : null,


                    isContentManager || isAdmin ? (
                        <Resource
                            name={CITIES.SOURCE}
                        />
                    ) : null,
                    isContentManager || isAdmin ? (
                        <Resource
                            name={AREAS.SOURCE}

                        />
                    ) : null,

                    <Resource name={APP_VERSIONS.SOURCE} />,


                ];
            }}

        </Admin>
    );
};

export default App;
